module.exports = __webpack_public_path__ + "static/media/hide.2686acbb.svg";